import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import ServiceOne from "../components/ServiceOne";
import CTAOne from "../components/CTAOne";
import AboutOne from "../components/AboutOne";
import MarqueeOne from "../components/MarqueeOne";
import FaqOne from "../components/FaqOne";
import FooterOne from "../components/FooterOne";
import HeaderThree from "../components/HeaderThree";
import HeroTwo from "../components/HeroTwo";

const HomeOne = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 500);
  }, []);
  return (
    <>
      {active === true && <Preloader />}

      <HelmetReact title={"Home"} />

      <HeaderThree />

      <HeroTwo />

      <ServiceOne />

      <CTAOne />

      <AboutOne />

      <div className="space-bottom"></div>

      <MarqueeOne />

      <div className="faq-area-1 bg-smoke space">
        <FaqOne />
      </div>

      <FooterOne />
    </>
  );
};

export default HomeOne;
